import { render } from "./AppSvgFront.vue?vue&type=template&id=d2065166&scoped=true"
import script from "./AppSvgFront.vue?vue&type=script&lang=js"
export * from "./AppSvgFront.vue?vue&type=script&lang=js"

import "./AppSvgFront.vue?vue&type=style&index=0&id=d2065166&lang=scss&scoped=true"

import exportComponent from "/Users/carolinehansen/Sites/work-manyone/koebenhavns-kommune/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2065166"]])

export default __exports__